var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 16,
    viewBox: "0 0 82 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3856 8.3698C43.3856 4.63223 46.4617 1.60101 50.1072 1.60101C53.7556 1.60101 56.8285 4.63223 56.8285 8.3698C56.8285 12.1103 53.7556 15.1392 50.1072 15.1392C46.4615 15.1392 43.3856 12.1103 43.3856 8.3698ZM50.107 0.871094C46.0667 0.871094 42.5938 4.22859 42.5938 8.3698C42.5938 12.5117 46.0667 15.8693 50.107 15.8693C54.1506 15.8693 57.625 12.5117 57.625 8.3698C57.625 4.22859 54.1506 0.871094 50.107 0.871094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6925 1.19922H20.8633L27.68 15.8712H27.7569L34.5736 1.19922H33.7477L29.5952 10.147L27.7209 14.2913L25.8515 10.147L21.6925 1.19922Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4219 15.4613H69.1856V8.3698L69.1448 2.69466L81.3389 15.8685H81.4158V1.19655H80.652V8.3698L80.6929 14.0417L68.4971 0.871094H68.4219V15.4613Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02287 10.7342L4.98415 6.51026L6.85204 2.36103L8.74953 6.51909L10.6917 10.7408L3.02287 10.7342ZM6.89636 0.871094H6.81311L0 15.4603H0.830501L2.72996 11.3675L10.978 11.3642L12.8824 15.4603H13.7091L6.89636 0.871094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2686345a335d4fd194ad9107df3e13e4.svg";
export { ForwardRef as ReactComponent };